import { Phone, Mail, Instagram } from "lucide-react";

const LINKS = [
  { label: "Home", href: "#top" },
  { label: "Services", href: "#services" },
  { label: "Pricing", href: "#pricing" },
  { label: "About Us", href: "#about" },
  { label: "Request a Quote", href: "#quote" },
  { label: "Contact", href: "#contact" },
];

const Footer = () => (
  <footer className="border-t border-[#8E7CC3]/15 bg-[#FAF8FF] pb-24 pt-16 md:pb-16" data-testid="footer">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div className="grid gap-12 md:grid-cols-3">
        <div>
          <img
            src="/logo.png"
            alt="Glow & Shine Sisters Cleaning Co."
            className="h-32 w-auto"
            data-testid="footer-logo"
          />
          <p className="mt-4 text-sm italic text-[#6B6776]">“Making every space glow &amp; shine”</p>
          <div className="mt-6 flex gap-3">
            <a
              href="https://www.instagram.com/cleanandshinesisters"
              target="_blank"
              rel="noopener noreferrer"
              className="flex h-10 w-10 items-center justify-center rounded-full border border-[#8E7CC3]/25 text-[#8E7CC3] transition-all duration-300 hover:scale-105 hover:border-[#D4AF37]/50 hover:text-[#674EA7]"
              title="Follow us on Instagram"
              aria-label="Glow & Shine Sisters on Instagram"
              data-testid="footer-instagram-link"
            >
              <Instagram className="h-4 w-4" aria-hidden="true" />
            </a>
          </div>
        </div>

        <nav aria-label="Footer navigation">
          <p className="text-xs font-semibold uppercase tracking-widest text-[#6B6776]">Quick Links</p>
          <ul className="mt-5 grid grid-cols-2 gap-3">
            {LINKS.map((l) => (
              <li key={l.href}>
                <a
                  href={l.href}
                  data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                  className="text-sm font-medium text-[#2C2A35] transition-colors hover:text-[#674EA7]"
                >
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
        </nav>

        <div>
          <p className="text-xs font-semibold uppercase tracking-widest text-[#6B6776]">Contact</p>
          <a href="tel:+18563080562" className="mt-5 flex items-center gap-3 text-sm font-medium text-[#2C2A35] hover:text-[#674EA7]" data-testid="footer-phone-link">
            <Phone className="h-4 w-4 text-[#D4AF37]" aria-hidden="true" /> +1 (856) 308-0562
          </a>
          <a href="mailto:Glowandshinesisterscleaningco@gmail.com" className="mt-3 flex items-center gap-3 break-all text-sm font-medium text-[#2C2A35] hover:text-[#674EA7]" data-testid="footer-email-link">
            <Mail className="h-4 w-4 shrink-0 text-[#D4AF37]" aria-hidden="true" /> Glowandshinesisterscleaningco@gmail.com
          </a>
        </div>
      </div>

      <div className="mt-14 border-t border-[#8E7CC3]/10 pt-8 text-center">
        <p className="text-xs text-[#6B6776]">
          © {new Date().getFullYear()} Glow &amp; Shine Sisters Cleaning Co. · Camden, New Jersey
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
